import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { IconTile } from './IconTile';

export interface EmptyStateProps {
  /** Icon rendered inside the top-centered IconTile. */
  icon: React.ReactNode;
  /** Heading text (h5). */
  title: React.ReactNode;
  /** Supporting sentence rendered in body2/muted. */
  description: React.ReactNode;
  /** Optional call-to-action (typically a `<Button>`). */
  action?: React.ReactNode;
}

/**
 * Centered empty-state panel: icon tile, title, description, and an
 * optional action. Follows spec §3.7.
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
}) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        px: 4,
        py: 6,
        width: '100%',
      }}
    >
      <Stack spacing={2} alignItems="center" textAlign="center">
        <IconTile>{icon}</IconTile>
        <Typography variant="h5" component="div">
          {title}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ maxWidth: 480 }}
        >
          {description}
        </Typography>
        {action && <Box sx={{ mt: 1 }}>{action}</Box>}
      </Stack>
    </Paper>
  );
};

export default EmptyState;
